import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FileUploader from '../FileUploader';
import { uploadToServer } from '../../api/api-client';


import useStyle from './style';

const FileUploaderAjax = ({ onChange, onProgress, onClear, path, value, onStartUpload, onComplete, ...props}) => {
    
    const classes = useStyle();
    const [progress, setProgress] = useState(0)

    const handleAttachFile = async (file) => {
        setProgress(0);
        onChange && onChange(file);
        if (file) {
            onStartUpload && onStartUpload(file);        
            const { data } = await uploadToServer(path, [file], handleUploadProgress);
            data.fileName = file.name;
            onComplete && onComplete(data);
        }
    };

    const removeFile = async () => {
        setProgress(0);
        onClear && onClear();
    };

    const handleUploadProgress = percent => {
        setProgress(percent);
        onProgress && onProgress(percent);
    };

    const currentProgress = () => value && value.fileName ? '100%' :`${progress * 100}%`;

    return <div className={classes.root}>
        <FileUploader {...props}
            value={value && value.fileName}
            onClear={removeFile}
            onChange={handleAttachFile}>
            <span className={classes.progress} style={{ width: currentProgress()}}/>
        </FileUploader>
    </div>
}

FileUploaderAjax.propTypes = {
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onStartUpload: PropTypes.func,
    onProgress: PropTypes.func,
    onComplete: PropTypes.func,
    onClear: PropTypes.func,
    value: PropTypes.object,
}

export default FileUploaderAjax;